import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormControl, Validators } from '@angular/forms';

import { defer, distinctUntilChanged, map, startWith } from 'rxjs';

import { AddEvaluationDropdownForm } from '@recruitee/evaluations-types';

@Injectable()
export class AddEvaluationDropdownFormService {
  private readonly fb = inject(FormBuilder);

  public readonly form: AddEvaluationDropdownForm = this.fb.group({
    offerId: new FormControl<number | null>(null),
    templateId: new FormControl<number | null>(null, Validators.required),
  });

  public readonly offerId$ = defer(() =>
    this.form.controls.offerId.valueChanges.pipe(startWith(this.form.controls.offerId.value)),
  ).pipe(distinctUntilChanged());
  public readonly isValid = toSignal(
    this.form.statusChanges.pipe(map(status => status === 'VALID')),
    { initialValue: this.form.valid },
  );

  public setOfferId(offerId: number | null): void {
    this.form.controls.offerId.setValue(offerId);
  }

  public setTemplateId(templateId: number | null): void {
    this.form.controls.templateId.setValue(templateId);
  }
}
